export default "__VITE_ASSET__DCDKXaNn__"